import { Static, Type } from '@sinclair/typebox'

export const TenantTier = Type.Union([
    Type.Literal('standalone'),
    Type.Literal('business'),
    Type.Literal('smart'),
    Type.Literal('no_access'),
])
export type TenantTier = Static<typeof TenantTier>

export const KizeoTenantTier = Type.Union([
    Type.Literal('business'),
    Type.Literal('smart'),
    Type.Literal('no_access'),
])
export type KizeoTenantTier = Static<typeof KizeoTenantTier>

export const KizeoTenantPolicy = Type.Object({
    tier: KizeoTenantTier,
    monthlyTasksQuota: Type.Number(),
    maxActiveFlows: Type.Union([Type.Number(), Type.Null()]),
    mcpEnabled: Type.Boolean(),
    advancedPiecesEnabled: Type.Boolean(),
})
export type KizeoTenantPolicy = Static<typeof KizeoTenantPolicy>

export const StandaloneTenantPolicy = Type.Object({
    tier: Type.Literal('standalone'),
    monthlyTasksQuota: Type.Number(),
    maxActiveFlows: Type.Null(),
    mcpEnabled: Type.Boolean(),
    advancedPiecesEnabled: Type.Boolean(),
})
export type StandaloneTenantPolicy = Static<typeof StandaloneTenantPolicy>

export const TenantPolicy = Type.Union([
    KizeoTenantPolicy,
    StandaloneTenantPolicy,
])
export type TenantPolicy = Static<typeof TenantPolicy>
